import { useLayoutEffect } from "react";
import { getLegacyFlag, getMobileDeviceFlag } from "@utils/toolbarItemUtils";
import { isDeviceOnExperimentalMode } from "@utils/userAgentUtils";
import classNames from "classnames";
import { ClassName } from "@constants/styles";

// TODO [LOWA-30534] From: https://tiny.amazon.com/tbu480k0
export const useSetBackgroundStyle = (isProcessedUrlParams: boolean) => {
    useLayoutEffect(() => {
        if (!isProcessedUrlParams) {
            return;
        }
        // TODO For mobile users, present the legacy experience until we can resolve the on-screen keyboard issue. (https://issues.amazon.com/issues/LOWA-11655)
        const isLegacy = getLegacyFlag() || isDeviceOnExperimentalMode();
        const isMobileFlagOn = getMobileDeviceFlag();
        const shouldUseLegacy = isLegacy && !isMobileFlagOn;
        const body = document.getElementsByTagName("body")[0];

        body.className = classNames(body.className, {
            [ClassName.LEGACY_BODY_BACKGROUND_STYLE]: shouldUseLegacy,
            [ClassName.EUC_BODY_BACKGROUND_STYLE]: !shouldUseLegacy,
        });
    }, [isProcessedUrlParams]);
};
